(function () {
  'use strict';

  /* @ngdoc object
   * @name wbPrints
   * @description
   *
   */
  angular
    .module('wbPrints', [
      'ui.router'
    ]);
}());
